import { Box, Typography, useMediaQuery } from '@mui/material'
import { useFormik } from 'formik'
import { t } from 'i18next'
import FormikContext from '../../../context/formikContext'
import FieldWithLabel from '../../../components/common/fields/fieldWithLabel'
import OutlinedFieldFormik from '../../../components/formik/fields/outlinedFieldFormik'
import ContainedButton from '../../../components/common/buttons/containedButton'
import ResetButton from '../../../components/common/buttons/resetButton'

interface SearchFiltersProps {
  onSearch: (searchTerm: string) => void
  resultsCount: number
}

const SearchFilters = ({ onSearch, resultsCount }: SearchFiltersProps) => {
  const isMobile = useMediaQuery('(max-width:1000px)')

  const formik = useFormik({
    initialValues: {
      search: '',
    },
    onSubmit: (values) => {
      onSearch(values.search)
    },
  })

  const handleReset = () => {
    formik.resetForm()
    onSearch('')
  }

  return (
    <>
      {/* Rechercher Section */}
      <Typography 
        variant="h2" 
        sx={{
          fontFamily: 'DIN',
          fontWeight: 500,
          fontSize: '24px',
          lineHeight: '32px',
          letterSpacing: '0px',
          mb: '24px'
        }}
      >
        Rechercher
      </Typography>

      {/* Search Section */}
      <Box
        sx={{
          display: 'flex',
          alignItems: isMobile ? 'flex-start' : 'center',
          justifyContent: isMobile ? 'center' : 'space-between',
          mb: '48px',
          flexDirection: isMobile ? 'column' : 'row',
          gap: isMobile ? '16px' : '0'
        }}
      >
        <Box sx={{
          display: 'flex',
          gap: isMobile ? '16px' : '24px',
          flexDirection: isMobile ? 'column' : 'row',
          width: isMobile ? '100%' : 'auto'
        }}>
          <FormikContext.Provider value={formik}>
            <FieldWithLabel 
              label={t('pages.personification.searchLabel')}
              sx={{
                '& .MuiFormLabel-root': {
                  fontFamily: 'DIN Alternate',
                  fontWeight: 700,
                  fontSize: '14px',
                  lineHeight: '18px',
                  letterSpacing: '0px',
                }
              }}
            >
              <OutlinedFieldFormik
                sx={{
                  width: isMobile ? '100%' : '416px',
                  mt: '-12px'
                }}
                name='search'
                placeholder={t('pages.personification.searchPlaceholder') || ''}
              />
            </FieldWithLabel>

            <ContainedButton
              sx={{
                alignSelf: 'end',
                width: isMobile ? '100%' : '158px',
                height: '44px',
                gap: '8px',
                py: '11px',
                px: '30px',
                fontSize: '12px',
              }}
              title={t('pages.personification.buttons.search')}
              handleClick={() => formik.handleSubmit()}
            />
          </FormikContext.Provider>
        </Box>
        
        {formik.isSubmitting && formik.dirty && (
          <ResetButton 
            handleClick={handleReset}
            sx={{
              width: isMobile ? '100%' : 'auto',
            }}
          />
        )}
      </Box>

      {/* Results Count */}
      <Typography sx={{ fontWeight: '500', mb: '15px!important' }}>
        {t('pages.personification.resultsCount')} : {resultsCount}
      </Typography>
    </>
  )
}

export default SearchFilters
